import { Loader2 } from 'lucide-react';
import { cn } from '@shared/lib/cn';

export function Spinner({ className }: { className?: string }) {
  return <Loader2 aria-hidden className={cn('h-5 w-5 animate-spin text-slate-400', className)} />;
}

/** Full-viewport loader used while the session is being restored at startup. */
export function FullPageSpinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div role="status" aria-live="polite" className="flex min-h-screen items-center justify-center">
      <Spinner className="h-8 w-8" />
      <span className="sr-only">{label}</span>
    </div>
  );
}
